import API, { baseURL } from './api';
import { getSucursalInfo, getUserInfo } from './auth';

// Client for sge_infantil_core's routes/product.js (mounted at /api/product)
// and the related baseUnit/packageType lookup tables.
export async function listProducts(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/product/${id}`);
}

export async function createProduct(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/product`, { sucursalId, createdBy: getUserInfo()?.id, ...payload });
}

export async function updateProduct(id, payload) {
  return API.put(`${baseURL}api/product/${id}`, payload);
}

export async function deleteProduct(id) {
  return API.delete(`${baseURL}api/product/${id}`);
}

export async function listBaseUnits(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/baseUnit/${id}`);
}

export async function listPackageTypes(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/packageType/${id}`);
}
